import logo from "../../assets/images/logo.png";

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <img
      src= {logo} // Replace with your actual image path
      alt="Loading"
      className="w-52 h-auto animate-pulse"
      style={{ 
        animationDuration: '1.5s',  // Adjust speed as needed
      }}
    />
  </div>
);

export default LoadingSpinner;